var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotifition3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H13.2857M9.28571 22H15M12.1429 4.85714C6.99179 4.85714 6.48408 7.64316 6.43404 8.19236C6.42833 8.25505 6.42337 8.31692 6.41302 8.37901L5.32604 14.9009C5.29946 15.0604 5.23934 15.2124 5.14965 15.347L4.18453 16.7946C3.67821 17.5541 4.22265 18.5714 5.13545 18.5714H19.1503C20.0631 18.5714 20.6075 17.5541 20.1012 16.7946L19.1361 15.347C19.0464 15.2124 18.9863 15.0604 18.9597 14.9009L17.8727 8.37901C17.8623 8.31692 17.8574 8.25505 17.8517 8.19236C17.8016 7.64316 17.2939 4.85714 12.1429 4.85714Z",
    stroke: "#363A44",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotifition3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notifition3.06aa65a76a2cd8af3ff3906d2306cc15.svg";